import React from "react";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { functions } from "../../../../globals/firebase";
import { httpsCallable } from "firebase/functions";

const CheckoutForm = (price) => {

  const stripepromisse = loadStripe(process.env.REACT_APP_STRIPE_PKLIVE);

  const userData = localStorage.getItem("user");
  if (!userData) {
    console.warn("User not found in localStorage");
    return null;
  }
  
  const user = JSON.parse(userData);
  if (!user.email) {
    console.warn("User email not found in user data");
    return null;
  }

  const useremail = user.email;

  const fetchClientSecret = async () => {
    try {
      const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
      const response = await createCheckoutSession({
        price: price.dataprice,
        customer_email: useremail,
        return_url: `${window.location.origin}/job-list?session_id={CHECKOUT_SESSION_ID}`
      });
      return response.data.clientSecret;
    } catch (error) {
      console.error("Error creating checkout session:", error);
      // Retornar null ou lançar erro para o Checkout lidar
      throw error;
    }
  };

  let options = { fetchClientSecret };

  return (
    <EmbeddedCheckoutProvider
      stripe={stripepromisse}
      options={options}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}

export default CheckoutForm;
